import { render } from "./heigei-footer.vue?vue&type=template&id=67ea677a&scoped=true"
const script = {}

import "./heigei-footer.vue?vue&type=style&index=0&id=67ea677a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ea677a"]])

export default __exports__